module.exports = __webpack_public_path__ + "static/media/icono-lupa.38ea64c7.svg";